import { datadogRum } from "./datadogRum";
import { isDatadogRumEnabled } from "./config";

// Thin, guarded wrapper around `datadogRum.addAction` for custom RUM actions
// (e.g. key user journeys). No-op when RUM is disabled. Keep `context` free of
// PII - pass counts/types/ids of non-personal entities only.
export const trackAction = (name: string, context?: object): void => {
  if (!isDatadogRumEnabled()) return;

  datadogRum.addAction(name, context);
};
